export default __webpack_public_path__ + "static/media/pizzaIcon.e558cf16.png";